import { useState, useCallback } from "react";
import { ReactLenis, useLenis } from "lenis/react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Services } from "@/components/Services";
import { Manifesto } from "@/components/Manifesto";
import { Stats } from "@/components/Stats";
import { Portals } from "@/components/Portals";
import { Connect } from "@/components/Connect";
import { Footer } from "@/components/Footer";

function Site() {
  const [tab, setTab] = useState("quote");
  const lenis = useLenis();

  const scrollToId = useCallback((id) => {
    const el = document.getElementById(id.replace("#", ""));
    if (!el) return;
    if (lenis) lenis.scrollTo(el, { offset: -70 });
    else el.scrollIntoView({ behavior: "smooth" });
  }, [lenis]);

  const openConnect = useCallback((which) => {
    setTab(which);
    setTimeout(() => scrollToId("connect"), 40);
  }, [scrollToId]);

  return (
    <div className="App grain bg-ink">
      <Navbar onQuote={() => openConnect("quote")} onCarrier={() => openConnect("carrier")} onNavigate={scrollToId} />
      <main>
        <Hero onQuote={() => openConnect("quote")} onCarrier={() => openConnect("carrier")} />
        <EditorialMarquee />
        <Services />
        <Manifesto />
        <Stats />
        <Portals />
        <Connect tab={tab} setTab={setTab} />
      </main>
      <Footer onQuote={() => openConnect("quote")} />
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <Site />
    </ReactLenis>
  );
}

export default App;
